<template>
  <div class="login-warpper">
    <div class="container-img">
      <div class="login-img">
        <!--				<img src="../../assets/images/logo4.png" alt="">-->
        <h1 class="websiteTitle" v-text="websiteTitle"></h1>
      </div>
      <div class="container">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="container-header">
          <el-tab-pane label="账号密码登录" name="usernameLogin"></el-tab-pane>
          <!-- <el-tab-pane label="验证码登录" name="captchaLogin"></el-tab-pane> -->
        </el-tabs>
        <!-- <infoForm title="账号密码登录" fromType="login" @on-submit="submitHandle" submit="登录" align2="忘记密码" @on-align="onAlign"></infoForm> -->
        <infoForm ref="infoForm" :loginType="activeName === 'usernameLogin' ? usernameLogin : captchaLogin
          " @on-submit="submitHandle" submit="登录" align="注册" align2="忘记密码" @on-align="onAlign"></infoForm>
      </div>
    </div>
    <div class="record_num" v-text="icp_number"></div>
  </div>
</template>

<script>
import util from "@/utils";
import infoForm from "@/components/infoForm/index.vue";
import cookie from "@/utils/cookie.js";
// import { login, useCaptchaLogin } from "@/api/index.js";
import { getDoctorToken, getPharmcistById } from "@/api";
import { encryptData } from '@/utils/aes.js'

export default {
  name: "Login",
  components: {
    infoForm,
  },
  props: {},
  data() {
    return {
      username: "",
      icp_number: util.icp_number,
      websiteTitle: process.env.VUE_APP_COPYRIGHT_FULL_NAME,
      activeName: "usernameLogin",
      usernameLogin: {
        // type : true 密码登录  type : false 验证码登录
        type: true,
        imgCaptcha: true,
        inputType: "password",
        placeholderNameOne: "手机号 / 用户名",
        placeholderNameTwo: "请输入密码",
        placeholderNameThree: "请输入验证码",
      },
      captchaLogin: {
        type: false,
        title: "验证码登录",
        inputType: "text",
        placeholderNameOne: "手机号",
        placeholderNameTwo: "请输入验证码",
      },
    };
  },
  mounted() { },
  methods: {
    onAlign(type) {
      if (type === "1") {
        this.go("/register");
      } else if (type === "2") {
        this.go("/forget");
      }
    },
    go(url) {
      this.$router.push({
        path: url,
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    /**
     * 登录
     */
    async submitHandle(userInfo) {
      const that = this;
      const passwordAes = encryptData(userInfo.password, userInfo.salt)
      var params = {
        username: userInfo.username,
        password: passwordAes,
        captcha: userInfo.imgCaptcha,
        checkKey: userInfo.checkKey,
      };

      const res = await getDoctorToken(params);
      if (res.code == 1) {
        util.setStore("user_token", res.data.token);
        util.setStore("user_id", res.data.id);
        util.setStore("userType", res.data.userType);
        util.setStore("isLogin", true);
        util.setStore("user_mobile", userInfo.username);
        this.getPharmcistById()
        setTimeout(function () {
          that.go("/index/work/appointment");
        }, 1500);
      } else {
        that.$message({
          showClose: true,
          message: res.message,
          type: "error",
        });
        if (res.message === "验证码错误~") {
          this.$refs.infoForm.handleChangeCheckCode();
        }
      }
    },
    loginHandle(res) {
      const that = this;
      if (res.code == 1) {
        util.setStore("user_token", res.data);
        util.setStore("isLogin", true);
        util.setStore("user_mobile", userInfo.username);
        setTimeout(function () {
          that.go("/index/work/appointment");
        }, 1500);
      } else {
        that.$message({
          showClose: true,
          message: res.message,
          type: "error",
        });
        if (res.message === "验证码错误~") {
          this.$refs.infoForm.handleChangeCheckCode();
        }
      }
    },
    // 获取药师信息
    async getPharmcistById() {
      const { code, data } = await getPharmcistById();
      if (code === 1) {
        util.setStore("userInfo", data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-warpper {
  background-image: url("../../assets/images/login-bg2.jpg");
  width: 100%;
  height: 100%;
  // position: relative;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-content: center;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .container-header {
    display: flex;
    margin-top: 30px;
  }

  .container-img {
    position: relative;
    top: 15%;
    // left: 50%;
    // margin: -300px 0 0 -175px;
    width: 400px;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;

    .login-img {
      text-align: center;
      margin: 20px 0;
    }

    .websiteTitle {
      width: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 30px;
      // color: #fc701a;
      font-family: Noto Sans S Chinese;
      font-weight: bold;
    }
  }

  .login-img img {
    height: 70px;
  }

  .container {
    background: #ffffff;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;
    box-shadow: 0 0 8px #fc9710;
    margin: 10px 20px 30px 20px;
  }

  .loginBtn {
    text-align: center;

    button {
      width: 100%;
      height: 36px;
      margin-bottom: 10px;
    }
  }
}
</style>
